import type { MutatedProduct } from "constants/modelCompareData/types";
import type { SiteUrl } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import type { StoreId } from "@ubnt/store.core/lib/types";
import { partsToPathname } from "@ubnt/store.core/lib/utils/url";

const getStorePathParts = (
  storePathParts: MutatedProduct["storePathParts"],
  storeId: StoreId,
) => {
  if (typeof storePathParts === "function") {
    return storePathParts(storeId);
  }
  return storePathParts;
};

export const getStoreHref = ({
  product,
  createSiteUrl,
  storeId,
}: {
  product: MutatedProduct;
  createSiteUrl: (siteUrl: SiteUrl) => string;
  storeId: StoreId;
}) => {
  const storePathParts = getStorePathParts(product.storePathParts, storeId);

  if (!storePathParts) {
    return undefined;
  }

  const pathParts = [];

  if (storePathParts?.category) {
    pathParts.push("category", storePathParts?.category);
  }
  if (storePathParts?.collectionSlug) {
    pathParts.push("collections", storePathParts?.collectionSlug);
  }
  if (storePathParts?.productSlug) {
    pathParts.push("products", storePathParts?.productSlug);
  }

  const storePathString = partsToPathname(pathParts);

  return createSiteUrl([
    SiteId.Store,
    storePathString,
    storePathParts?.variant ? { variant: storePathParts.variant } : undefined,
  ]);
};
